import { observer } from 'mobx-react';
import React from 'react';
import { Link, PromiseMessage, PromiseRetry } from '../../../lib/components';
import { dateFormat, ReactNodeGenerator, Disposers } from '../../../lib/helpers';
import { routes } from '../../../pages/Routes';
import { ClassroomStatus, ClassroomStatusLabels } from '../../classroom/models/classroom-models';
import { StudentScheduleStore } from './StudentScheduleStore';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import $ from 'jquery';
import { httpClient } from 'domain/utils/httpClient';
import { environment } from 'lib/environment';
import Swal from 'sweetalert2';
import { reaction } from 'mobx';
import moment from 'moment';
import { userStatusService } from 'domain/index'
import { GuessServerTime } from 'lib/helpers/date/GuessServerTime';
import {
  HttpPromiseState,
  PromiseState
} from 'lib/helpers';
import { Classroom } from 'scenes/classroom/models/classroom-models';
import { StudentScheduleClassroomResponse } from 'domain/models/response-model';
import { Helmet, HelmetTags } from "react-helmet";
import { routerStore } from "lib/components/router/routerStore";
import q from 'q'
import { withTranslation, getI18n, WithTranslation } from 'react-i18next';
import { TFunction, t } from 'i18next';

const gStore = new StudentScheduleStore();

const SCHEDULER_ID: string = 'StudentSchedulerKendoUI';

export class StudentSchedulerKendoUI extends React.Component<{
  classroomScheduleHttpState: HttpPromiseState<StudentScheduleClassroomResponse>;
  t: TFunction;
  isEnglish: boolean;
}> {

  timezone: string = 'Etc/UTC';

  countdownIntervalId: number | undefined = undefined;

  idleIntervalId: number | undefined = undefined;
  idleTime: number = 0;

  componentWillUnmount() {
    var scheduler = $("#" + SCHEDULER_ID).data("kendoScheduler");
    if (scheduler) {
      scheduler.destroy();
    }
    if (this.countdownIntervalId) {
      window.clearInterval(this.countdownIntervalId);
    }
    if (this.idleIntervalId) {
      window.clearInterval(this.idleIntervalId);
    }
  }

  componentDidMount() {
    var self = this;
    var timezones = userStatusService.status.user?.TimeZone?.Name.split('/');
    var timezoneValue = userStatusService.status.user?.TimeZone?.Name;

    if (timezones && timezones.length > 2) {
      var [first, second] = timezones;
      timezoneValue = `${first}/${second}`;
    }

    // this.timezone = userStatusService.status.user?.TimeZone?.Name ?? 'Etc/UTC';
    this.timezone = timezoneValue ?? 'Etc/UTC';
    const t = getI18n().t;
    this.countdownIntervalId = window.setInterval(() => this.updateStartButtons(t), 1000);
    this.idleIntervalId = window.setInterval(() => {
      self.idleTime += 1;
      if (self.idleTime > 4) { // 5 minutes
        window.location.reload();
      }
    }, 60000);
    $(window.document).on('mousemove', function () {
      self.idleTime = 0;
    });
    $(window.document).on('keypress', function () {
      self.idleTime = 0;
    });
  }

  setupKendoScheduler = (newState: any, addedTags: HelmetTags, removedTags: HelmetTags) => {

    $("#" + SCHEDULER_ID).kendoScheduler({
      add: (e) => {
        e.preventDefault();
      },
      edit: (e) => {
        e.preventDefault();
      },
      move: (e) => {
        e.preventDefault();
      },
      remove: (e) => {
        e.preventDefault();
      },
      resize: (e) => {
        e.preventDefault();
      },
      moveStart: (e) => {
        e.preventDefault();
      },
      resizeStart: (e) => {
        e.preventDefault();
      },
      allDaySlot: false,
      currentTimeMarker: false,
      footer: false,
      date: gStore.serverTime.nowMoment.toDate(),
      height: 600,
      majorTimeHeaderTemplate: kendo.template(this.props.isEnglish ? `<span class="k-time">#=kendo.toString(date, 'hh.mm tt')#</span>` : `<span class="k-time">#=kendo.toString(date, 'HH')#.00</span>`),
      dateHeaderTemplate: kendo.template(`
      <div class="k-link k-nav-day k-date-wrapper d-flex justify-content-center #=kendo.date.isToday(date)?'current':''#">
          <div class="k-date-weekday mr-1">#=kendo.toString(date, 'ddd')#</div>
          <div class="k-date-day">#=kendo.toString(date, ' d').trim()#</div>
      </div>`),
      views: [
        {
          type: "agenda",
          title: this.props.t('schedule.agenda'),
          selected: true,
          eventTemplate: $("#classroom-template-agenda").html(),
          eventTimeTemplate: $("#event-time-template").html(),
        },
        { type: "day", title: this.props.t('schedule.day') },
        { type: "week", title: this.props.t('schedule.week') },
        { type: "month", title: this.props.t('schedule.month') }
      ],
      editable: {
        destroy: false
      },
      messages: {
        today: this.props.t('schedule.today'),
        date: this.props.t('schedule.date'),
        time: this.props.t('schedule.time'),
        event: this.props.t('schedule.event'),
      }
    });
    if (this.props.classroomScheduleHttpState.isResolved) {
      this.updateDataSource();
    }
    reaction(() => this.props.classroomScheduleHttpState.value, () => {
      this.updateDataSource();
    });

    $("#" + SCHEDULER_ID).on('click', '.btn-action-marker', (evt) => {
      const $btn = $(evt.target);
      const action: string = $btn.data('action');
      const classroomId: number = $btn.data('classroomid');
      switch (action) {
        case "Start":
          this.btnActionStart(classroomId);
          break;
        case "SuggestTime":
          this.btnActionSuggestTime(classroomId);
          break;
        case "ApproveTime":
          this.btnActionApproveTime(classroomId);
          break;
        case "DeclineTime":
          this.btnActionDeclineTime(classroomId);
          break;
        case "DeclineAndSuggestTime":
          this.btnActionDeclineAndSuggestTime(classroomId);
          break;
      }
    });
  }

  btnActionStart = (classroomId: number) => {
    routerStore.navigateTo(routes.studentClassroom(classroomId));
  }

  btnActionSuggestTime = (classroomId: number) => {
    if (gStore.scheduledClassrooms == null) {
      return;
    }
    const found = gStore.scheduledClassrooms.find((x) => x.ClassRoomId == classroomId);
    if (!found) {
      return;
    }
    gStore.suggestedClassRoom = found;
  }

  async btnActionDeclineTime(classRoomId: number) {
    let url = `${environment.apiServer}/student/classroom-decline-time`;
    const request: ClassroomAcceptTimeRequest = {
      ClassRoomId: classRoomId
    }
    await httpClient.axios.postWithSweetAlert<any>(url, request);
    Swal.fire({ icon: 'success' });
    gStore.load();
  }

  btnActionDeclineAndSuggestTime = (classroomId: number) => {
    if (gStore.scheduledClassrooms == null) {
      return;
    }
    const found = gStore.scheduledClassrooms.find((x) => x.ClassRoomId == classroomId);
    if (!found) {
      return;
    }
    gStore.declinedAndSuggestedClassRoom = found;
  }

  btnActionApproveTime = (classroomId: number) => {
    if (gStore.scheduledClassrooms == null) {
      return;
    }
    const found = gStore.scheduledClassrooms.find((x) => x.ClassRoomId == classroomId);
    if (!found) {
      return;
    }
    gStore.acceptClassRoom = found;
  }

  private async updateDataSource() {
    var self = this;
    if (this.props.classroomScheduleHttpState.isResolved == false) {
      return;
    }

    const scheduleData = this.props.classroomScheduleHttpState.value;
    var scheduler = $("#" + SCHEDULER_ID).data("kendoScheduler");
    const dsOptions = {
      data: scheduleData,
      schema: {
        data: "Events",
        model: {
          id: "taskId",
          fields: {
            taskId: { from: "ClassRoomId", type: "number" },
            title: { from: "Title", defaultValue: "No title", validation: { required: true } },
            start: { type: "date", from: "StartDate" },
            end: { type: "date", from: "EndDate" },
            endUser: { type: "date", from: "EndDateUser" },
            startTimezone: { from: "StartTimezone" },
            endTimezone: { from: "EndTimezone" },
            teacherId: { from: "TeacherId" },
            teacherName: { from: "TeacherName" },
            studentId: { from: "StudentId" },
            studentName: { from: "StudentName" },
            status: { from: "Status" },
            suggestionStartTime: { from: "SuggestionStartTime" },
            suggestionUserId: { from: "SuggestionUserId" },
            suggestionStartTimeFormatted: { from: "SuggestionStartTimeFormatted" },
            showSuggestButton_Computed: { from: "ShowSuggestButton_Computed" },
            showApproveButton_Computed: { from: "ShowApproveButton_Computed" },
            showStartButton_Computed: { from: "ShowStartButton_Computed" },
            suggestLabel: { from: "SuggestLabel" },
            scheduledStartTimeUnix: { from: "ScheduledStartTime" },
          }
        },
        parse: (data: StudentScheduleClassroomResponse) => {
          $.each(data.Events, (i, classroom) => {
            const classroomAny: any = classroom;
            let bResult: boolean;
            classroomAny.SuggestionStartTimeFormatted = dateFormat(classroom.SuggestionStartTime, 'wymdhm', true);
            // showStartButton
            classroomAny.ShowStartButton_Computed = classroom.Status === 'InProgress';
            // showSuggestButton
            bResult = classroom.Status === 'Scheduled'
              && ((classroom.SuggestionStartTime == null && classroom.SuggestionDeclineTime != null)
                || (classroom.SuggestionStartTime != null && classroom.SuggestionApproveUserId != null)
                || (classroom.SuggestionStartTime == null && classroom.SuggestionApproveUserId == null && classroom.SuggestionDeclineTime == null)
              );
            classroomAny.ShowSuggestButton_Computed = bResult;
            // showApproveButton
            bResult = classroom.Status === 'Scheduled'
              && classroom.SuggestionStartTime != null
              && classroom.SuggestionUserId != null
              && classroom.StudentId != classroom.SuggestionUserId
              && classroom.SuggestionApproveUserId == null;
            classroomAny.ShowApproveButton_Computed = bResult;
            // suggestLabel
            let suggestLabel: string | null = null;
            const hasSuggestion = classroom.Status === 'Scheduled'
              && classroom.SuggestionStartTime != null
              && classroom.SuggestionUserId != null;
            const wasDeclined = classroom.Status === 'Scheduled'
              && classroom.SuggestionDeclineTime != null
              && classroom.SuggestionApproveUserId != null
              && classroom.SuggestionStartTime == null;
            const wasDeclinedAndSuggested = classroom.Status === 'Scheduled'
              && classroom.SuggestionDeclineTime != null
              && classroom.SuggestionApproveUserId == null
              && classroom.SuggestionStartTime != null;
            if (hasSuggestion) {
              if (classroom.SuggestionApproveUserId == null) {
                suggestLabel = this.props.t('schedule.change-time-suggested', { time: dateFormat(classroom.SuggestionStartTime, 'wymdhm', true) })
              }
              else {
                const newTime = dateFormat(classroom.ScheduledStartTime, 'wymdhm', true);
                const oldTime = dateFormat(classroom.SuggestionApproveOldTime, 'wymdhm', true);
                suggestLabel = this.props.t('schedule.change-time-approved', { newTime, oldTime })
              }
            }
            if (wasDeclined) {
              suggestLabel = this.props.t('schedule.change-time-declined', { time: dateFormat(classroom.SuggestionDeclineTime, 'wymdhm', true) })
            }
            if (wasDeclinedAndSuggested) {
              suggestLabel = this.props.t('schedule.change-time-declined-and-suggested', { oldTime: dateFormat(classroom.SuggestionDeclineTime, 'wymdhm', true), newTime: dateFormat(classroom.SuggestionStartTime, 'wymdhm', true) })
            }
            classroomAny.SuggestLabel = suggestLabel;
            classroomAny.StartDate = moment.utc(classroom.Start).toDate();
            classroomAny.EndDateUser = moment.utc(classroom.End).toDate();
            let startDay = moment.utc(classroom.Start).toDate().getDay();
            let endDay = moment.utc(classroom.End).toDate().getDay();
            if (startDay != endDay) {
              //if lesson is between 2 days, we must set lesson end time to end of the starting day 11:59
              classroomAny.EndDate = moment.utc(moment.utc(classroom.Start).set('minute', 59)).toDate();
            }
            else {
              classroomAny.EndDate = moment.utc(classroom.End).toDate();
            }
          });
          return data;
        }
      },
    };
    (dsOptions.schema as any).timezone = self.timezone;
    var dataSource = new kendo.data.SchedulerDataSource(dsOptions);
    scheduler.setDataSource(dataSource);
    await q.delay(0);
    self.updateStartButtons(this.props.t);
  }

  *renderer(): ReactNodeGenerator {
    yield (
      <Helmet key="Helmet" onChangeClientState={this.setupKendoScheduler}>
        <script id="classroom-template-agenda" type="text/x-kendo-template" key="ScriptEventTemplateAgenda">
          {
            `<div class="clasroom-template-agenda">
              <p>${this.props.t('schedule.teacher')}: #: teacherName #</p>
              <p>#: title #</p>
              <p>${this.props.t('schedule.status')}: #: status #</p>
              #if (data.suggestLabel) {#
                <p>#= suggestLabel #</p>
              #}#
              <p class="classroom-btn-group-wrapper">
                <button class="btn btn-success btn-action-marker btn-action-start animate__animated animate__flash animate__infinite animate__slower" data-action="Start" data-classroomid="#= taskId #" data-classroom-status="#= status #" data-classroom-start-unix="#= scheduledStartTimeUnix #" style="display: none;">${this.props.t('button.start')}</button>
                #if (data.showSuggestButton_Computed) {#
                  <button class="btn btn-primary btn-action-marker" data-action="SuggestTime" data-classroomid="#= taskId #">${this.props.t('schedule.suggest-time')}</button>
                #}#
                #if (data.showApproveButton_Computed) {#
                  <button class="btn btn-primary btn-action-marker" data-action="ApproveTime" data-classroomid="#= taskId #">${this.props.t('schedule.approve-time')}Approve time</button>
                  <button class="btn btn-primary btn-action-marker" data-action="DeclineTime" data-classroomid="#= taskId #">${this.props.t('schedule.decline')}Decline</button>
                  <button class="btn btn-primary btn-action-marker" data-action="DeclineAndSuggestTime" data-classroomid="#= taskId #">${this.props.t('schedule.decline-and-suggest-time')}Decline & Suggest time</button>
                #}#
              </p>                       
            </div>`
          }
        </script>
        <script id="classroom-template" type="text/x-kendo-template" key="ScriptEventTemplate">
          {
            `<div className="clasroom-template">
              <p>#: studentName #. #: title #</p>
            </div>`
          }
        </script>
        <script id="event-time-template" type="text/x-kendo-template">
          {
            `#= kendo.toString(start, "t") # - #= kendo.toString(endUser, "t") #
            `
          }
        </script>
      </Helmet>
    );

    yield (
      <div id={SCHEDULER_ID} key="StudentSchedulerDiv"></div>
    );
  }

  render() {
    return Array.from(this.renderer());
  }

  updateStartButtons(t: any) {
    const self = this;

    function inProgress($btn: JQuery<HTMLElement>, startTimeUnixSeconds: number, status: ClassroomStatus, t: any) {
      const btnText = t('button.start');
      $btn.removeAttr('disabled')
        .removeClass('disabled')
        .removeClass('btn-outline-success')
        .addClass('animate__animated')
        .addClass('btn-success')
        .text(btnText)
        .show();
    }

    function scheduled($btn: JQuery<HTMLElement>, startTimeUnixSeconds: number, status: ClassroomStatus, t: any) {
      const btnText = t('button.start-in', { time: gStore.serverTime.remainingTimeString(startTimeUnixSeconds) });
      $btn.attr('disabled', 'disabled')
        .removeClass('animate__animated')
        .removeClass('btn-success')
        .addClass('disabled')
        .addClass('btn-outline-success')
        .text(btnText)
        .show();
    }


    $('.btn-action-start').each((x, el) => {
      const $btn = $(el);
      var dataObj = $btn.data();
      const startTimeUnixSeconds: number = parseInt(dataObj.classroomStartUnix)
        + 30; // Add 30 seconds, give a change to background task "MarkClassroomsInProgress" to set Classroom status to InProgress
      const status: ClassroomStatus = dataObj.classroomStatus;
      switch (status) {
        case 'InProgress':
          inProgress($btn, startTimeUnixSeconds, status, t);
          break;
        case 'Scheduled':
          const reached: boolean = gStore.serverTime.reached(startTimeUnixSeconds);
          if (reached) {
            inProgress($btn, startTimeUnixSeconds, status, t);
          } else {
            scheduled($btn, startTimeUnixSeconds, status, t);
          }
          break;
        default:
          $btn.hide();
      }
    })
  }
}

function* renderer(store: StudentScheduleStore, t: any, isEnglish: boolean): ReactNodeGenerator {
  if (store.scheduleClassroomsState == null)
    return;
  const state = store.scheduleClassroomsState;

  yield (<PromiseMessage key="loader-state"
    label={t('schedule.loading')} state={state} align="right" />);

  yield (<PromiseRetry key="retry-actions"
    state={state} retry={store.load} align="right" />);

  yield (<StudentScheduleSceneSuggestTimeModal key='StudentScheduleSceneSuggestTimeModal' />);
  yield (<StudentScheduleSceneDeclineTimeModal key='StudentScheduleSceneDeclineTimeModal' />);
  yield (<StudentScheduleSceneAcceptTimeModal key='StudentScheduleSceneAcceptTimeModal' />);


  if (!state.isResolved)
    return;

  yield (<StudentSchedulerKendoUI key='StudentSchedulerKendoUI' classroomScheduleHttpState={state} t={t} isEnglish={isEnglish} />);
}

@observer
class StudentScheduleScene extends React.Component<WithTranslation> {
  store: StudentScheduleStore;
  t: TFunction;
  isEnglish: boolean;

  constructor(props: WithTranslation) {
    super(props);
    this.store = gStore;
    this.t = props.t;
    this.isEnglish = props.i18n.language == 'en-US';
  }

  componentDidMount() {
    this.store.load();
  }

  componentDidUpdate() {
  }

  componentWillUnmount() {
    this.store.dispose();
  }

  render() {
    return Array.from(renderer(this.store, this.t, this.isEnglish));
  }
}

interface ClassroomSuggestTimeRequest {
  ClassRoomId: number;
  DateAndTime: string;
}

interface ClassroomAcceptTimeRequest {
  ClassRoomId: number;
}

type SuggestModalState = {
  isOpen: boolean;
}

type DeclineModalState = {
  isOpen: boolean;
}

type ApproveModalState = {
  isOpen: boolean;
}

class StudentScheduleSceneSuggestTimeModalComponent extends React.Component<WithTranslation, SuggestModalState> {

  private readonly disposers = new Disposers();
  t: TFunction;

  constructor(props: WithTranslation) {
    super(props);
    this.state = { isOpen: false };
    this.t = props.t;
  }

  componentDidMount() {
    this.disposers.add(reaction(() => gStore.suggestedClassRoom, () => {
      this.setState({ isOpen: gStore.suggestedClassRoom != null });
    }))
  }

  componentWillUnmount() {
    this.disposers.dispose();
  }

  render() {
    const teacherName = gStore.suggestedClassRoom?.TeacherName;
    const lessonTitle = gStore.suggestedClassRoom?.Title;
    return (
      <Modal isOpen={this.state.isOpen}
        size="md"
        centered={true}
        onOpened={this.onOpened}>
        <ModalHeader>
          <div>{this.t('schedule.suggest-time')}</div>
        </ModalHeader>
        <ModalBody>
          <p>{this.t('schedule.teacher')}: <strong>{teacherName}</strong></p>
          <p>{this.t('schedule.lesson')}: <strong>{lessonTitle}</strong></p>
          <p><input id="suggestDatetimepicker" /></p>
        </ModalBody>
        <ModalFooter>
          <button type="button" className="btn btn-light"
            onClick={this.onCloseClick}>
            {this.t('button.close')}
          </button>
          <button type="button" className="btn btn-primary"
            onClick={this.onSubmitClick}>
            {this.t('button.suggest')}
          </button>
        </ModalFooter>
      </Modal>
    );
  }

  onOpened = () => {
    $("#suggestDatetimepicker").kendoDateTimePicker({
      value: new Date(),
      dateInput: true
    });
  }

  onCloseClick = () => {
    gStore.suggestedClassRoom = null;
  }

  onSubmitClick = async () => {
    const classRoom = gStore.suggestedClassRoom;
    if (!classRoom) {
      return;
    }
    var datetimepicker = $("#suggestDatetimepicker").data("kendoDateTimePicker");
    let url = `${environment.apiServer}/student/classroom-suggest-time`;
    var momentDate = moment(datetimepicker.value());
    const request: ClassroomSuggestTimeRequest = {
      ClassRoomId: classRoom.ClassRoomId,
      DateAndTime: momentDate.format()
    }

    try {
      await httpClient.axios.postWithSweetAlert<any>(url, request);
      gStore.suggestedClassRoom = null;
      Swal.fire({ icon: 'success', confirmButtonText: this.t('button.ok') });
      gStore.load();
    } catch (err) {
      Swal.fire({ icon: 'error', text: 'Check date and time you suggest', confirmButtonText: this.t('button.ok') });
    }
  }
}

const StudentScheduleSceneSuggestTimeModal = withTranslation()(StudentScheduleSceneSuggestTimeModalComponent);

class StudentScheduleSceneDeclineTimeModalComponent extends React.Component<WithTranslation, DeclineModalState> {

  private readonly disposers = new Disposers();
  t: TFunction;

  constructor(props: WithTranslation) {
    super(props);
    this.state = { isOpen: false };
    this.t = props.t;
  }

  componentDidMount() {
    this.disposers.add(reaction(() => gStore.declinedAndSuggestedClassRoom, () => {
      this.setState({ isOpen: gStore.declinedAndSuggestedClassRoom != null });
    }))
  }

  componentWillUnmount() {
    this.disposers.dispose();
  }

  render() {
    const teacherName = gStore.declinedAndSuggestedClassRoom?.TeacherName;
    const lessonTitle = gStore.declinedAndSuggestedClassRoom?.Title;
    return (
      <Modal isOpen={this.state.isOpen}
        size="md"
        centered={true}
        onOpened={this.onOpened}>
        <ModalHeader>
          <div>{this.t('schedule.decline-and-suggest-time')}</div>
        </ModalHeader>
        <ModalBody>
          <p>{this.t('schedule.teacher')}: <strong>{teacherName}</strong></p>
          <p>{this.t('schedule.lesson')}: <strong>{lessonTitle}</strong></p>
          <p><input id="declineSuggestDatetimepicker" /></p>
        </ModalBody>
        <ModalFooter>
          <button type="button" className="btn btn-light"
            onClick={this.onCloseClick}>
            {this.t('button.close')}
          </button>
          <button type="button" className="btn btn-primary"
            onClick={this.onSubmitClick}>
            {this.t('button.suggest')}
          </button>
        </ModalFooter>
      </Modal>
    );
  }

  onOpened = () => {
    $("#declineSuggestDatetimepicker").kendoDateTimePicker({
      value: new Date(),
      dateInput: true
    });
  }

  onCloseClick = () => {
    gStore.declinedAndSuggestedClassRoom = null;
  }

  onSubmitClick = async () => {
    const classRoom = gStore.declinedAndSuggestedClassRoom;
    if (!classRoom) {
      return;
    }
    var datetimepicker = $("#declineSuggestDatetimepicker").data("kendoDateTimePicker");
    let url = `${environment.apiServer}/student/classroom-decline-suggest-time`;
    var momentDate = moment(datetimepicker.value());
    const request: ClassroomSuggestTimeRequest = {
      ClassRoomId: classRoom.ClassRoomId,
      DateAndTime: momentDate.format()
    }

    await httpClient.axios.postWithSweetAlert<any>(url, request);
    gStore.declinedAndSuggestedClassRoom = null;
    Swal.fire({ icon: 'success', confirmButtonText: this.t('button.ok') });
    gStore.load();
  }
}

const StudentScheduleSceneDeclineTimeModal = withTranslation()(StudentScheduleSceneDeclineTimeModalComponent);

class StudentScheduleSceneAcceptTimeModalComponent extends React.Component<WithTranslation, ApproveModalState> {

  private readonly disposers = new Disposers();
  t: TFunction;

  constructor(props: WithTranslation) {
    super(props);
    this.state = { isOpen: false };
    this.t = props.t;
  }

  componentDidMount() {
    this.disposers.add(reaction(() => gStore.acceptClassRoom, () => {
      this.setState({ isOpen: gStore.acceptClassRoom != null });
    }))
  }

  componentWillUnmount() {
    this.disposers.dispose();
  }

  render() {
    const teacherName = gStore.acceptClassRoom?.TeacherName;
    const lessonTitle = gStore.acceptClassRoom?.Title;
    const suggestionStartTime: number | null = gStore.acceptClassRoom?.SuggestionStartTime ?? null;
    return (
      <Modal isOpen={this.state.isOpen}
        size="md"
        centered={true}
        onOpened={this.onOpened}>
        <ModalHeader>
          <div>{this.t('schedule.accept-time')}</div>
        </ModalHeader>
        <ModalBody>
          <p>{this.t('schedule.teacher')}: <strong>{teacherName}</strong></p>
          <p>{this.t('schedule.lesson')}: <strong>{lessonTitle}</strong></p>
          <p>{this.t('schedule.time')}: <strong>{dateFormat(suggestionStartTime, 'wymdhm', true)}</strong></p>
        </ModalBody>
        <ModalFooter>
          <button type="button" className="btn btn-light"
            onClick={this.onCloseClick}>
            {this.t('button.close')}
          </button>
          <button type="button" className="btn btn-primary"
            onClick={this.onSubmitClick}>
            {this.t('button.accept')}
          </button>
        </ModalFooter>
      </Modal>
    );
  }

  onOpened = () => {

  }

  onCloseClick = () => {
    gStore.acceptClassRoom = null;
  }

  onSubmitClick = async () => {
    const classRoom = gStore.acceptClassRoom;
    if (!classRoom) {
      return;
    }
    let url = `${environment.apiServer}/teacher/classroom-approve-time`;
    const request: ClassroomAcceptTimeRequest = {
      ClassRoomId: classRoom.ClassRoomId,
    }
    await httpClient.axios.postWithSweetAlert<any>(url, request);
    gStore.acceptClassRoom = null;
    Swal.fire({ icon: 'success', confirmButtonText: this.t('button.ok') });
    gStore.load();
  }
}

const StudentScheduleSceneAcceptTimeModal = withTranslation()(StudentScheduleSceneAcceptTimeModalComponent);

export default withTranslation()(StudentScheduleScene);